import * as React from "react";
import type { useMe } from "@chotca/api-client";
import { AnalyticsUserProperty } from "@chotca/config";
import { setAnalyticsIdentity } from "@/lib/analytics";
import { setSentryUser } from "@/lib/sentry";

type Me = NonNullable<ReturnType<typeof useMe>["data"]>;

// Sets Firebase/GA4 identity + segmentation properties for the signed-in
// employer so every funnel report can be sliced by org. Rendered inside the
// authed area where `me` is guaranteed. org_id is the join key that lets the
// employer-side funnel line up with worker-side events. No PII.
export function AnalyticsIdentitySync({ me }: { me: Me }) {
  const orgId = me.memberships[0]?.orgId ?? null;

  React.useEffect(() => {
    setAnalyticsIdentity(me.id, {
      [AnalyticsUserProperty.role]:
        me.globalRole === "ADMIN" ? "admin" : "employer",
      [AnalyticsUserProperty.orgId]: orgId,
    });
    setSentryUser(me.id);
  }, [me.id, me.globalRole, orgId]);

  return null;
}
